import React, { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { OptionalDataTestIdProp } from 'Shared/utils/props/dataTestIdProp';

interface ColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?:
    | 'third'
    | 'sixth'
    | 'full'
    | 'threeFourths'
    | 'half'
    | 'quarter'
    | 'eighth';
}

export const Column: FC<ColumnProps & OptionalDataTestIdProp> = ({
  variant = 'full',
  className,
  children,
  'data-testid': dataTestId,
  ...rest
}) => {
  const columnClassName = classNames(styles.col, styles[variant], className);
  return (
    <div data-testid={dataTestId} {...rest} className={columnClassName}>
      {children}
    </div>
  );
};
